import { useState, useEffect } from 'react';

const banners = [
  {
    id: 1,
    title: 'Equipamentos Gamer de Alta Performance',
    subtitle: 'As melhores ofertas em hardware e periféricos',
    cta: 'Ver Ofertas',
    image: 'https://public.readdy.ai/ai/img_res/53fc99b13d2d511fe6a2dbddd79c0cca.jpg'
  },
  {
    id: 2,
    title: 'Monte Seu PC Gamer dos Sonhos',
    subtitle: 'Personalize cada componente do seu setup',
    cta: 'Começar Agora',
    image: 'https://readdy.ai/api/search-image?query=Custom%20gaming%20PC%20build%20with%20transparent%20case%20showing%20RGB%20components%2C%20high-performance%20graphics%20card%20with%20glowing%20lights%2C%20liquid%20cooling%20system%2C%20modern%20computer%20hardware%2C%20professional%20product%20photography%2C%20dramatic%20lighting%20with%20neon%20colors%2C%20sharp%20focus%2C%20isolated%20on%20dark%20background%2C%20centered%20composition%2C%20realistic%20style%2C%20premium%20quality%2C%20the%20PC%20should%20take%20up%2070%25%20of%20the%20frame&width=1920&height=600&seq=hero-banner-2&orientation=landscape'
  },
  {
    id: 3,
    title: 'Periféricos Premium',
    subtitle: 'Headsets, teclados e mouses profissionais',
    cta: 'Explorar',
    image: 'https://readdy.ai/api/search-image?query=Premium%20gaming%20peripherals%20collection%2C%20professional%20gaming%20headset%20with%20RGB%20lighting%2C%20mechanical%20keyboard%20with%20colorful%20backlighting%2C%20precision%20gaming%20mouse%2C%20modern%20gaming%20accessories%2C%20professional%20product%20photography%2C%20dramatic%20lighting%20with%20neon%20pink%20and%20cyan%20accents%2C%20sharp%20focus%2C%20isolated%20on%20dark%20background%2C%20centered%20composition%2C%20realistic%20style%2C%20premium%20quality%2C%20the%20peripherals%20should%20take%20up%2070%25%20of%20the%20frame&width=1920&height=600&seq=hero-banner-3&orientation=landscape'
  }
];

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const handleCtaClick = () => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE('/catalogo');
    }
  };

  return (
    <section className="relative h-[600px] overflow-hidden">
      {banners.map((banner, index) => (
        <div
          key={banner.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="absolute inset-0">
            <img
              src={banner.image}
              alt={banner.title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-gray-900/80 via-gray-900/60 to-gray-950"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-neon-pink/10 via-transparent to-neon-cyan/10"></div>
          </div>
          
          <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
            <div className="text-white max-w-2xl">
              <h1 className="text-5xl md:text-6xl font-bold mb-4 animate-glow">
                {banner.title}
              </h1>
              <p className="text-xl md:text-2xl mb-8 text-gray-300">
                {banner.subtitle}
              </p>
              <button 
                onClick={handleCtaClick}
                className="bg-gradient-to-r from-neon-pink to-neon-cyan hover:shadow-neon-pink text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                {banner.cta}
              </button>
            </div>
          </div>
        </div>
      ))}

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-10">
        {banners.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`h-3 rounded-full transition-all cursor-pointer ${
              index === currentSlide 
                ? 'bg-gradient-to-r from-neon-pink to-neon-cyan w-8 shadow-neon-pink' 
                : 'bg-white/30 hover:bg-white/50 w-3'
            }`}
          />
        ))}
      </div>
    </section>
  );
}
